import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import './footer.scss';
import { Button } from "../common";
import { get, post } from './../../utility/apiClient';
import { errorTypesEnum } from './../../utility/enums';
import { GtagEvent } from './../../utility/googleAnalytics';

// Asset import
import Visa from '../../assets/img/footer/visa.png';
import Amex from '../../assets/img/footer/amex.png';
import SafeKey from '../../assets/img/footer/safeKey.png';
import MasterCard from '../../assets/img/footer/masterCard.png';
import KeellsLogo from '../../assets/img/logo/KeellsWhiteLogo.png';

/**-- Imports for redux --*/
import { connect } from 'react-redux';
import { showMessageBox } from '../../redux/actions/messageBoxActions';
import { showLoadingScreen, hideLoadingScreen } from '../../redux/actions/loadingScreenActions';

// map the redux states to props
function mapStateToProps(state) {
    return {
        loadingScreenVisible: state.loadingScreen
    }
};

// map the redux actions to props
const mapDispatchToProps = {
    showMessageBox,
    showLoadingScreen,
    hideLoadingScreen
};

class Footer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            subscribeMail: "",
        }
    }

    Subscribe() {
        let isValid = true;
        let errorCode = 0;
        if (this.state.subscribeMail === "") {
            isValid = false;
            errorCode = 1;
        }
        else if (!(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(this.state.subscribeMail)) {
            isValid = false;
            errorCode = 2;
        }
        if (isValid) {
            this.props.showLoadingScreen();
            let newsLetter = {
                Email: this.state.subscribeMail
            }
            post(`/MyAccount/SaveNewsLetterDetails`, newsLetter).then(response => {
                if (response.data.statusCode === 200) {
                    // GtagEvent({ action: 'subscribe', category: 'form', label: 'newsletter subscribe' });
                    let messageBox = {
                        show: true,
                        title: "Subscribe Newsletter",
                        className: "success",
                        content: response.data.errorList[0].statusMessage,
                        isConfirmation: false,
                        callBackFunction: null
                    }
                    this.props.showMessageBox(messageBox);
                    this.setState({
                        subscribeMail: ""
                    })
                } else {
                    let errorType = response.data.errorList[0].errorType;
                    let messageBox = {
                        show: true,
                        title: errorTypesEnum.error === errorType ? "Oops!" : errorTypesEnum.warning === errorType ? "Warning" : "Information",
                        className: errorTypesEnum.error === errorType ? "error" : errorTypesEnum.warning === errorType ? "warning" : "info",
                        content: response.data.errorList[0].statusMessage,
                        isConfirmation: false,
                        callBackFunction: null
                    }
                    this.props.showMessageBox(messageBox);
                }
                this.props.hideLoadingScreen();
            })
        }
        else {
            let messageBox = {
                show: true,
                title: "Subscribe Email",
                className: "error",
                content: errorCode === 1 ? "Subscribe email is required" : "Invalid email address",
                isConfirmation: false,
                callBackFunction: null
            }
            this.props.showMessageBox(messageBox);
        }
    }
    handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    render() {
        return (<div className="footer-container">
            <div className="footer-links">
                <Col xs="12" md={{ span: 10, offset: 1 }}>
                    <Row className="m-0 align-items-center">
                        <Col lg="2" md="3" xs="12" className="footer-link-top-row-item">
                            <img className="img-fluid" src={KeellsLogo}></img>
                        </Col>
                        <Col className="footer-link-top-row-item">
                            <input id="subscribeMail" name="subscribeMail" placeholder="Enter your email to subscribe to our newsletter" type="text"
                                className="form-control"
                                value={this.state.subscribeMail}
                                onChange={this.handleChange.bind(this)}
                                aria-describedby="UserNameHelpBlock" />
                            <Button primary floatRight appendToTextBox id="buttonDesign" onClick={this.Subscribe.bind(this)}>Submit</Button>
                        </Col>
                        <Col lg="auto" md="12" sm="12" xs="12" className="footer-link-top-row-item footer-link-social-link-holder pr-0 d-flex justify-content-end">
                            <div className="social-link-without-design">
                                <a href="https://www.facebook.com/Keells.SL/" target="_blank"  >
                                    <div className="footer-link-social-link"><i className="fab fa-facebook-f" ></i></div>
                                </a>
                                <a href="https://twitter.com/keells_sl" target="_blank">
                                    <div className="footer-link-social-link"><i className="fab fa-twitter"></i></div>
                                </a>
                                <a href="https://www.youtube.com/channel/UCCu17kGGZjuVITjK4Z_0N0g" target="_blank">
                                    <div className="footer-link-social-link"><i className="fab fa-youtube"></i></div>
                                </a>
                            </div>
                        </Col>
                        <Col lg="12" md="12" sm="12" xs="12" className="footer-link-top-row-item footer-link-social-link-holder">
                            <div className="social-link-design">
                                <a href="https://www.facebook.com/Keells.SL/" target="_blank">
                                    <div className="footer-link-social-link"><i className="fab fa-facebook-f" ></i></div>
                                </a>
                                <a href="https://twitter.com/keells_sl" target="_blank">
                                    <div className="footer-link-social-link"><i className="fab fa-twitter"></i></div>
                                </a>
                                <a href="https://www.youtube.com/channel/UCCu17kGGZjuVITjK4Z_0N0g" target="_blank">
                                    <div className="footer-link-social-link"><i className="fab fa-youtube"></i></div>
                                </a>
                            </div>
                        </Col>

                    </Row>
                    <Row className="m-0 row-cols-2 row-cols-xs-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 align-items-top">
                        <Col lg="4" md="12" xs="12" className="footer-link-holder footer-link-holder-main">
                            <div id="FooterTitle">Jaykay Marketing Services Pvt Ltd.<br />No:148, Vauxhall Street, Colombo 2, Sri Lanka.</div>
                            {/* <a href="mailto:keellscustomercare.jms@keells.com"> <div className="footer-email-holder">keellscustomercare.jms@keells.com </div></a> */}
                            <br></br>
                            <div className="footer-phone-number-holder"><i className="fas fa-phone"></i>+94 11 2303500</div>
                            <div>(Daily operating hours 8.00a.m to 8.00p.m)</div>
                            {/* <div className="footer-phone-number-holder"><i className="fas fa-fax"></i>+94 11 2303555</div> */}
                        </Col>

                        {/* For  Small Screens*/}
                        <Col lg="12" md="12" xs="12" className="accordianTab">
                            <div className="tabs footer-link-holder">
                                <div className="tab">
                                    <input type="radio" id="rd1" name="rd" className="rd" />
                                    <label className="footer-link-heading tab-label" htmlFor="rd1">Quick Links</label>
                                    <div className="tab-content">
                                        <div className="footer-link-item" onClick={() => { window.location.href = ("/") }}>Home</div>
                                        <div className="footer-link-item" onClick={() => { window.location.href = ("//keells-tabloid") }}>Catalogue & Deals</div>
                                        {/* <div className="footer-link-item" onClick={() => { window.location.href = ("/contactus") }}>Contact us</div> */}
                                        {/* <div className="footer-link-item" onClick={() => { window.location.href = ("/utilityPayment") }}>Utility bill payments</div> */}
                                        <div className="footer-link-item" onClick={() => { window.location.href = ("/welcome/TrackOrder") }}>Track my order</div>
                                    </div>
                                </div>
                                <div className="tab">
                                    <input type="radio" id="rd2" name="rd" className="rd" />
                                    <label className="footer-link-heading tab-label" htmlFor="rd2">Categories</label>
                                    <div className="tab-content">
                                        <div className="footer-link-item" onClick={() => { window.location.href = ("/grocery") }}>Grocery</div>
                                        <div className="footer-link-item" onClick={() => { window.location.href = ("/beverages") }}>Beverages</div>
                                        <div className="footer-link-item" onClick={() => { window.location.href = ("/household-essentials") }}>Household</div>
                                        <div className="footer-link-item" onClick={() => { window.location.href = ("/fresh-vegetables") }}>Vegetables</div>
                                        <div className="footer-link-item" onClick={() => { window.location.href = ("/fresh-fruits") }}>Fruits</div>
                                        {/* <div className="footer-link-item">Exclusively at Keells</div> */}
                                    </div>
                                </div>
                                <div className="tab">
                                    <input type="radio" id="rd3" name="rd" className="rd" />
                                    <label className="footer-link-heading tab-label" htmlFor="rd3">Useful Links</label>
                                    <div className="tab-content">
                                        <div className="footer-link-item" onClick={() => { window.location.href = "/privacynotice"; }}>Privacy Notice</div>
                                        <div className="footer-link-item" onClick={() => { window.location.href = "/keells-faq"; }}>FAQ</div>
                                        <div className="footer-link-item" onClick={() => { window.location.href = "/TermsAndConditions"; }}>Terms and Conditions</div>
                                        <div className="footer-link-item" onClick={() => { window.location.href = "/store-locator"; }}>Stores</div>
                                        <div className="footer-link-item" onClick={() => { window.location.href = "/keells-delivery-grid"; }}>Delivery grid</div>
                                    </div>
                                </div>
                                <div className="tab">
                                    <input type="radio" id="rd4" name="rd" className="rd" />
                                    <label className="footer-link-heading tab-label" htmlFor="rd4">Customer Service</label>
                                    <div className="tab-content">
                                        <div className="footer-link-item" onClick={() => { window.location.href = "/get-in-touch"; }} >Contact us</div>
                                        <div className="footer-link-item" onClick={() => { window.location.href = "/about-us"; }}>About us </div>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        {/* For  Large Screens*/}
                        <Col lg="2" md="3" xs="12" className="footer-link-holder footer-link-holder-sub">
                            <div className="footer-link-heading">Quick Links</div>
                            <div className="footer-link-item" onClick={() => { window.location.href = ("/") }}>Home</div>
                            <div className="footer-link-item" onClick={() => { window.location.href = ("/keells-tabloid") }}>Catalogue & Deals</div>
                            {/* <div className="footer-link-item" onClick={() => { window.location.href=("/contactus") }}>Contact us</div> */}
                            <div className="footer-link-item" onClick={() => { window.location.href = ("/utility-bill-payment") }}>Utility bill payments</div>
                            <div className="footer-link-item" onClick={() => { window.location.href = ("/welcome/TrackOrder") }}>Track my order</div>
                        </Col>
                        <Col lg="2" xs="12" className="footer-link-holder footer-link-holder-sub">
                            <div className="footer-link-heading">Categories</div>
                            <div className="footer-link-item" onClick={() => { window.location.href = ("/grocery") }}>Grocery</div>
                            <div className="footer-link-item" onClick={() => { window.location.href = ("/beverages") }}>Beverages</div>
                            <div className="footer-link-item" onClick={() => { window.location.href = ("/household-essentials") }}>Household</div>
                            <div className="footer-link-item" onClick={() => { window.location.href = ("/fresh-vegetables") }}>Vegetables</div>
                            <div className="footer-link-item" onClick={() => { window.location.href = ("/fresh-fruits") }}>Fruits</div>
                            {/* <div className="footer-link-item">Exclusively at Keells</div> */}

                        </Col>
                        <Col lg="2" xs="12" className="footer-link-holder footer-link-holder-sub">
                            <div className="footer-link-heading">Useful Links</div>
                            <div className="footer-link-item" onClick={() => { window.location.href = "/privacynotice"; }}>Privacy Notice</div>
                            <div className="footer-link-item" onClick={() => { window.location.href = "/keells-faq"; }}>FAQ</div>
                            <div className="footer-link-item" onClick={() => { window.location.href = "/TermsAndConditions"; }}> Terms and Conditions</div>
                            <div className="footer-link-item" onClick={() => { window.location.href = "/store-locator"; }}>Stores</div>
                            <div className="footer-link-item" onClick={() => { window.location.href = "/keells-delivery-grid"; }} >Delivery grid</div>
                        </Col>
                        <Col lg="2" xs="12" className="footer-link-holder footer-link-holder-sub">
                            <div className="footer-link-heading">Customer Service</div>
                            <div className="footer-link-item" onClick={() => { window.location.href = "/get-in-touch"; }}>Contact us</div>
                            <div className="footer-link-item" onClick={() => { window.location.href = "/about-us"; }}>About us </div>
                        </Col>
                    </Row>
                </Col>
            </div>
            <div className="footer-bottom">
                <Col xs="12" md={{ span: 10, offset: 1 }}>
                    <Row className="m-0 align-items-center">
                        <Col lg="auto" md="12" xs="12">
                            Copyright © {new Date().getFullYear()} Jaykay Marketing Services (Pvt) Ltd. All Rights Reserved
                        </Col>
                        <Col lg="auto" md="12" xs="12" className="ml-auto footer-payment-method-holder">
                            <img className="img-fluid footer-payment-method-image" src={Visa}></img>
                            <img className="img-fluid footer-payment-method-image" src={MasterCard}></img>
                            <img className="img-fluid footer-payment-method-image" src={Amex}></img>
                            <img className="img-fluid" src={SafeKey}></img>
                        </Col>
                    </Row>
                </Col>
            </div>
        </div>);
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Footer);